// tablePageSizeConstants.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

export const tablePageSizeDefault = 20
